import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { claimActions } from 'store';
import { AccordionFullTable } from 'components';
import { useModal } from 'utils';
import { ReceivableBillTable } from 'fragments';
import { completedClaimTableInfo } from './constants';
import { CompletedTotals } from './completedTotals';
import { COMPLETED } from '../../../fragments/billing/claims/claimDetails/constants';

export const CompletedClaims = () => {
    const submittedClaims = useSelector((state) => state.claim.claims);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open } = useModal();

    const renderParams = () => {
        const sendInfo = {
            ...info,
            status: info?.status ? info?.status : COMPLETED,
        };
        delete sendInfo.page;
        delete sendInfo.tabType;
        delete sendInfo.clientFull;
        // Display-only companion for `payer` — forwarding it sends the payer's NAME as a
        // query param alongside its id. billableAppt.js already stripped it; these did not.
        delete sendInfo.funderName;
        sendInfo.skip = info?.skip ? info?.skip : 0;
        sendInfo.limit = 50;
        return sendInfo;
    };

    const getSubmittedClaims = (loading) => {
        dispatch(claimActions.getPendingClaims({ ...renderParams() }, loading));

        const agingParams = {
            ...renderParams(),
        };
        delete agingParams.skip;
        delete agingParams.limit;
        dispatch(claimActions.getCompletedClaimTotals(agingParams, loading));
    };

    useEffect(() => {
        getSubmittedClaims();
    }, [info]);

    return (
        <div style={{ marginTop: 12 }}>
            {/*<CompletedClaimFilters />*/}
            <CompletedTotals />
            <AccordionFullTable
                margin={'6px 0 0 0'}
                minWidth={1500}
                tableInfo={completedClaimTableInfo(navigate, info, getSubmittedClaims)}
                list={submittedClaims?.claims}
                listCount={submittedClaims?.count}
                onRowClick={(item) => open(<ReceivableBillTable defaultBill={item} />)}
            />
        </div>
    );
};
